import { useDispatch } from "react-redux";
import { signOutUser } from "features/user/userSlice";
import { signOutFirebaseUser } from "utils/firebase/firebase";

export default function useSignOutUser() {
  const dispatch = useDispatch();

  const handleSignOut = async () => {
    await signOutFirebaseUser();
    dispatch(signOutUser());
  };

  return handleSignOut;
}
